export const MLB_HEADSHOT = (id) =>
  `https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:67:current.png/w_213,q_auto:best/v1/people/${id}/headshot/67/current`;

export const GREEN = "#00c241";
export const BLACK = "#0f172a";
export const GRAY  = "rgba(15,23,42,0.08)";
